import { Component } from '@angular/core';
import { ModalService } from '../services/modal.service';

@Component({
  standalone: false,
  selector: 'mf-yes-or-no-modal',
  templateUrl: './yes-or-no-modal.component.html',
  styleUrls: ['./yes-or-no-modal.component.scss'],
})
export class YesOrNoModalComponent {
  constructor(private _modalService: ModalService) {
    this.title = this._modalService.openData.title;
    this.message = this._modalService.openData.message;
  }

  title: string;
  message: string | null;

  closeAsSuccess() {
    this._modalService.closeAsSuccess();
  }

  closeAsCancel() {
    this._modalService.closeAsCancel();
  }
}
